module.exports = __webpack_public_path__ + "img/MGA.e9b946d1.svg";